export default __webpack_public_path__ + "static/media/ballLoader.5df0afd0.webp";